import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import { AccountConfirm } from 'sg-ui-components';

const AccountConfirmPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <AccountConfirm user={user} actions={actions} cmsSourceFirebase={cmsSourceFirebase} config={config} />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountConfirmPage);
